import HTTP from '@/utils/http';

/**
 * @typedef {object} Plan
 * @property {string[]} scope
 */

const defaultState = () => ({
  /**
   * @type {Plan}
   */
  plan: {},
  permissions: {
    api: false,
    branding: false,
    team: false,
    allowlist: false,
  },
});

const planModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET_PLAN(state, { plan }) {
      state.plan = plan;
    },
    SET_PERMISSIONS(state, { permissions }) {
      state.permissions = permissions;
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
    GET({ commit, dispatch }) {
      return HTTP({
        method: 'get',
        url: 'plans/current',
      }).then((response) => {
        commit('SET_PLAN', { plan: response.data.data });
        dispatch('UPDATE_PERMISSIONS');
      });
    },
    UPDATE_PERMISSIONS({ commit, state }) {
      // const plan = state.plan; // eslint-disable-line prefer-destructuring

      const permissions = {
        api: false,
        branding: false,
        team: false,
        allowlist: false,
        bulk_send: false,
      };

      if (state.plan && state.plan.scope) {
        state.plan.scope.forEach((scope) => {
          switch (scope) {
            case 'plan_api':
              permissions.api = true;
              break;
            case 'plan_branding':
              permissions.branding = true;
              break;
            case 'plan_team':
              permissions.team = true;
              break;
            case 'plan_allowlist':
              permissions.allowlist = true;
              break;
            case 'plan_bulk_send':
              permissions.bulk_send = true;
              break;
            default:
          }
        });
      }

      commit('SET_PERMISSIONS', { permissions });
    },
  },
  getters: {
    plan: state => state.plan,
    /**
     * @returns {string[]}
     */
    scope: state => state.plan.scope,
    permissions: state => state.permissions,
    planHasFeature: state => feature => (state.permissions && Object.prototype.hasOwnProperty.call(state.permissions, feature) ? state.permissions[feature] : false),
    isTrialling: state => state.plan.id === 'free-trial',
  },
};

export default planModule;

/** @typedef {RefRT<typeof import('@/store/modules/plan').default.getters>} Getters */
